export default {
  label: {
    height: 32,
    display: 'flex' as 'flex',
    borderRadius: 3,
    alignItems: 'center',
    justifyContent: 'center',
  },
};
